import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import '../../../../../Content/krystal/css/pv-style.css';

const ProgramNavbar = (props) => {
    const { programName } = props;

    const programs = [
        {name: "DIRECTV", label: "DIRECTV"},
        {name: "Spectrum", label: "Spectrum"},
        {name: "Frontier", label: "Frontier"},
        {name: "Kinetic", label: "Kinetic"},
        {name: "EarthLink", label: "EarthLink"},
        { name: "HomeSecurity", label: "Home Security"},
        { name: "Optimum", label: "Optimum" },
        { name: "Xfinity", label: "Xfinity" },
        { name: "Verizon", label: "Verizon" }
    ];

    return (
            <div className="pv-partner-resources-category-links">
                <ul>
                    {programs.map((program) => {
                        return (
                            <li key={program.name}>
                                {(programName != null && programName.toLowerCase() === program.name.toLowerCase()) ? (
                                    <Link
                                        to={"/PartnerwithPV/AuthorizedRetailerProgram/" + `${program.name}`}
                                        onClick={(event) => event.preventDefault()}
                                        style={{ pointerEvents: 'none' }}
                                    >
                                        <strong>{program.label}</strong>
                                    </Link>
                                ) : (
                                    <Link
                                        to={"/PartnerwithPV/AuthorizedRetailerProgram/" + `${program.name}`}
                                    >
                                        <strong>{program.label}</strong>
                                    </Link>
                                )}
                            </li>
                        )
                    })}
                </ul>
            </div>
    );
};

export default ProgramNavbar;
